import Notice from './Notice';
import { setCookie, getCookie } from "../../utilities/storage";

document.addEventListener('DOMContentLoaded', () => {
  const $noticeElements = document.querySelectorAll('.js-notice');
  if (!$noticeElements.length) {
    return;
  }
  $noticeElements.forEach(($notice) => {
    const notice = new Notice($notice);

    if(!getCookie(notice.id)) {
      notice.on('close', () => {
        setCookie(notice.id, 1, notice.duration);
        notice.off('close');
        notice.unmount();
        notice.element.remove();
        notice.endElement?.focus();
      });
      notice.mount();
    }
  });
});
